export default "__VITE_ASSET__6f42b8da__"